/**
 * Some voices reported by the browser we want to exclude.
 * Sometimes because they are redundant, sometimes because they have compatibility issues.
 *
 * @method filterVoiceList
 * @param {Array} voiceList - array of available voices
 * @returns {Array} - reduced array of voices
 */
export const filterVoiceList = (voiceList) => {
  const newVoiceList = [];
  const bestMatchForName = {};

  voiceList.forEach((voice) => {
    // If there is no other voice with the same name, or this voice is en-US, use it.
    if (!bestMatchForName[voice.name] || voice.lang === 'en-US') {
      bestMatchForName[voice.name] = voice;
    }

    // If there is another voice with the same name, but it is not english and this one is, use it.
    if (
      !bestMatchForName[voice.name].lang.startsWith('en') &&
      voice.lang.startsWith('en')
    ) {
      bestMatchForName[voice.name] = voice;
    }

    // If there is another voice with the same name, but it is en-* and this one is en, use it.
    if (
      bestMatchForName[voice.name].lang.startsWith('en-') &&
      voice.lang === 'en'
    ) {
      bestMatchForName[voice.name] = voice;
    }
  });

  voiceList.forEach((voice) => {
    // Google voices cause problems across operating systems.
    // They are erratic on windows machines, i.e. stop/start randomly.
    // On Mac they cause performance issues with large manifest items.
    if (voice.name.includes('Google')) {
      return;
    }

    // Remove voices that are not "local services" i.e. need to reach to an external third party server.
    if (voice.localService === false) {
      return;
    }

    // If the voice is not the best match for its name, skip it.
    if (voice !== bestMatchForName[voice.name]) {
      return;
    }

    newVoiceList.push(voice);
  });

  // sort the final voice list by name
  newVoiceList.sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }

    if (a.name > b.name) {
      return 1;
    }

    return 0;
  });

  return newVoiceList;
};

export default filterVoiceList;
